// extracted by mini-css-extract-plugin
export default {"container":"MemoryGame_container__qkjyQ","cards":"MemoryGame_cards__UBTfm","tries":"MemoryGame_tries__ScMnB"};